import { connect } from 'react-redux';
import Signup from '../components/Signup/Signup';

import * as actions from '../redux/actions/Signup';
import { signout } from '../redux/actions/Signin';
import { IP_CHECK_TYPE } from '../constants/IpConstants';
import { postIpCheck } from '../redux/actions/Ip';

const mapStateToProps = (state) => {
  return {
    error: state.signup.error,
    letterPlans: state.signup.letterPlans,
    isLoading: state.signup.isLoading,
    pathname: state.router.location.pathname,
    ipCheck: state.signup.ipCheck,
    ipCheckLoading: state.signup.ipCheckLoading,
  };
};

const mapDispatchToProps = dispatch => ({
  signup(signupInfo) {
    dispatch(actions.signup(signupInfo));
  },

  signout() {
    dispatch(signout());
  },

  getLetterPlans() {
    dispatch(actions.getLetterPlans());
  },

  postIpCheck() {
    dispatch(postIpCheck(IP_CHECK_TYPE.SIGNUP));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Signup);



// WEBPACK FOOTER //
// ./src/containers/Signup.js